import { RefObject, useEffect, useRef } from 'react';

interface UseIntersectionObserverProps {
  onIntersect: () => void;
  root?: RefObject<HTMLElement>;
  enabled?: boolean;
}

export const useIntersectionObserver = ({
  onIntersect,
  root,
  enabled = true,
}: UseIntersectionObserverProps) => {
  const observerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          onIntersect();
        }
      },
      { threshold: 0, root: root?.current }
    );

    const currentObserverRef = observerRef.current;

    if (currentObserverRef) {
      observer.observe(currentObserverRef);
    }

    return () => {
      if (currentObserverRef) {
        observer.unobserve(currentObserverRef);
      }
    };
  }, [onIntersect, enabled, root]);

  return { observerRef };
};
